var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManeuvers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8477 18.6081L39.4046 30H4.86987L7.17352 25.9977C8.79313 25.6277 10.4691 25.238 12.1035 24.8471L10.4945 27.6426H29.5345L25.7245 21.0231C27.9967 20.275 30.4589 19.4361 32.8477 18.6081ZM30.5277 14.5775L22.1372 0L10.8509 19.6086C12.7354 18.6764 14.6612 17.8255 16.531 17.1547L20.0145 11.1027L22.5868 15.5717C25.1114 15.1127 27.8513 14.7955 30.5277 14.5775Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4079 18.7833C9.62816 21.5209 0 26.9962 0 26.9962C0 26.9962 11.8267 22.7377 19.4079 20.6084C26.9892 18.4791 42 14.7529 42 14.7529C42 14.7529 29.1877 16.0456 19.4079 18.7833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManeuvers);
export default __webpack_public_path__ + "static/media/maneuvers.2b98fa1c7d2ebc677b6dc99133d3665a.svg";
export { ForwardRef as ReactComponent };